export default __webpack_public_path__ + "static/media/S0020_6.10.1704210900000.b6992ee1.jpg";